var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkpagamentoNewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.16371 11H5.35631C5.07932 11.0002 4.81102 11.0967 4.59744 11.2731C4.38386 11.4494 4.23831 11.6946 4.18574 11.9665C4.13318 12.2384 4.17688 12.5202 4.30936 12.7634C4.44183 13.0066 4.65482 13.1962 4.91179 13.2996L6.74675 14.0329C7.00416 14.1358 7.21767 14.3252 7.3506 14.5685C7.48353 14.8117 7.52759 15.0937 7.4752 15.3659C7.42282 15.6381 7.27726 15.8835 7.06353 16.0601C6.8498 16.2366 6.58125 16.3332 6.30402 16.3333H4.49662",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.83008 11.0002V10.3335",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.83008 16.9999V16.3333",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.6178 8.39026C6.35725 8.35237 6.0943 8.33336 5.83101 8.33337C5.09418 8.33381 4.36542 8.48688 3.69069 8.78292C3.01596 9.07896 2.4099 9.51156 1.9107 10.0534C1.4115 10.5953 1.03001 11.2347 0.790259 11.9314C0.550511 12.628 0.457713 13.3667 0.517716 14.101C0.577719 14.8353 0.789221 15.5492 1.13889 16.1977C1.48856 16.8461 1.9688 17.4151 2.54935 17.8688C3.12991 18.3225 3.79817 18.651 4.51201 18.8336C5.22585 19.0162 5.96979 19.049 6.69693 18.9298",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.8333 4.33334H12.4991C11.7918 4.33334 11.1134 4.6143 10.6132 5.11439C10.113 5.61449 9.83203 6.29277 9.83203 7.00001V15.6667C9.83203 17.0812 10.394 18.4377 11.3944 19.4379C12.3947 20.4381 13.7515 21 15.1662 21C16.5809 21 17.9377 20.4381 18.938 19.4379C19.9384 18.4377 20.5004 17.0812 20.5004 15.6667V7.00001C20.5004 6.29277 20.2194 5.61449 19.7192 5.11439C19.219 4.6143 18.5407 4.33334 17.8333 4.33334Z",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.166 6.99997V9.66664",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.39258 2.60889L8.33584 3.552",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.498 2.33333V1",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M5.7832 5.66675H7.11675",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkpagamentoNewIcon);
export default __webpack_public_path__ + "static/media/linkpagamento-new-icon.56a16de4825f17b1fa227a33f1cfda65.svg";
export { ForwardRef as ReactComponent };